export const REDIRECTION_REASON_UNAUTHORIZED = 'unauthorized'
export const REDIRECTION_REASON_INACTIVITY = 'inactivity'
export const REDIRECTION_REASON_REFERRAL = 'referral'
export const REDIRECTION_REASON_REFERRAL_ERROR = 'referral-error'
